import clsx from 'clsx'

const CheckboxUnfilledIcon = ({
	size = 'large',
	isInactive = false,
	...props
}: {
	size: 'small' | 'large'
	isInactive?: boolean
}) => (
	<svg
		width={size === 'small' ? 16 : 24}
		height={size === 'small' ? 16 : 24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect
			x="0.5"
			y="0.5"
			width="23"
			height="23"
			rx="5.5"
			className={'fill-uiSecondaryLight dark:fill-uiTertiaryDark'}
		/>
		<rect
			x="0.5"
			y="0.5"
			width="23"
			height="23"
			rx="5.5"
			className={clsx(
				isInactive
					? 'stroke-textInactiveLight dark:stroke-grey900'
					: 'stroke-grey400 dark:stroke-grey800',
			)}
		/>
	</svg>
)

export default CheckboxUnfilledIcon
